export default function cleanUrl(url = "") {
  const pathArray = url.split("/").filter(x => x.length > 1)
  return pathArray[0]
}
